import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useMemo, useState } from 'react';
import ComboboxBase from './ComboboxBase';

function normalize(str) {
    return (str || '').trim().replace(/\s+/g, ' ');
}

const ComboboxSelect = forwardRef(
    (
        {
            label,
            name,
            autocomplete,
            error,
            disableTab,
            hint,

            value,
            onChange,

            options = [], // [{ value, label, disabled? }]
            allowCustomValue = true,

            helpText = 'Velg fra listen eller skriv selv',
            noResultsText = 'Ingen treff (du kan skrive fritt)',
            ...props
        },
        ref
    ) => {
        const [isOpen, setIsOpen] = useState(false);

        const query = normalize(value);

        const items = useMemo(() => {
            if (!query) return options;
            const q = query.toLowerCase();
            return options.filter(o => (o.label || '').toLowerCase().includes(q));
        }, [options, query]);

        const handleInputChange = e => {
            onChange?.(e);
            setIsOpen(true);
        };

        const handleSelect = opt => {
            onChange?.({ target: { name, value: opt.value } });
            setIsOpen(false);
        };

        const renderMeta = () => {
            if (!query) return <span className="combobox-meta__hint">{helpText}</span>;
            if (items.length === 0)
                return <span className="combobox-meta__hint">{noResultsText}</span>;
            return <span className="combobox-meta__hint">Velg fra listen</span>;
        };

        return (
            <ComboboxBase
                ref={ref}
                label={label}
                name={name}
                autocomplete={autocomplete}
                error={error}
                disableTab={disableTab}
                hint={hint}
                value={value}
                onInputChange={handleInputChange}
                onSelectOption={handleSelect}
                items={items.filter(i => !i.disabled)}
                isLoading={false}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                getOptionKey={opt => opt.value}
                getOptionLabel={opt => opt.label}
                getOptionSubLabel={null}
                renderMeta={renderMeta}
                icon={<FontAwesomeIcon icon={faChevronDown} aria-hidden="true" />}
                {...props}
            />
        );
    }
);

ComboboxSelect.displayName = 'ComboboxSelect';
export default ComboboxSelect;
